<template>
  <option-widget>
    <template v-slot:heading>Клиент-серверный режим работы (MS SQL)</template>
    <template v-slot:info>
      <div class="mb-12">
        Подходит для компаний с 5 и более пользователями, сохраняет производительность при высокой нагрузке.
      </div>
      <instruction-link name="msSql">Подробнее</instruction-link>
    </template>
    <template v-slot:controls>
      <div>
        200 руб. за пользователя в месяц
        <el-button
          v-if="isServiceActivated" class="w-100 mt-12" disabled
          type="success">
          Подключено <i class="el-icon-check"></i>
        </el-button>
        <el-button
          v-else class="w-100 mt-12" type="primary"
          :loading="$mip('requestServiceActivation')"
          :disabled="!$store.state.user.accInfo.isAdmin"
          @click="activateService">
          Подключить
        </el-button>
      </div>
    </template>
  </option-widget>
</template>

<script>
  import OptionWidget from './OptionWidget.vue'
  import InstructionLink from '@/components/InstructionLink.vue'

  const SQL_SERVICE_ID = 'be6bc2da-d935-11e9-ab53-00155d009008'

  export default {
    components: {
      OptionWidget,
      InstructionLink
    },

    computed: {
      isServiceActivated() {
        return this.$store
          .state
          .user
          .accInfo
          .services
          .some(service => service.id === SQL_SERVICE_ID)
      }
    },

    methods: {
      async activateService() {
        await this.$http.requestServiceActivation('Подключить ms sql')
        this.$notify({
          title: 'Подключение MS SQL',
          message: 'Ваша заявка принята. С вами свяжется менеджер',
          type: 'success'
        })
      }
    }
  }
</script>